export default "__VITE_ASSET__CnoufLB2__"